// extracted by mini-css-extract-plugin
export default {"productItem":"ProductItem_productItem__yi3vn","showHighlight":"ProductItem_showHighlight__xDSVk","description":"ProductItem_description__kMGIz"};